import type { PostnordJob } from '@/api/types'

export const POSTNORD_JOB_LABELS: Record<PostnordJob, string> = {
  shipment_motor: 'Bokning',
  shipment_tracking: 'Leveranssynk'
}

export const POSTNORD_JOB_DESCRIPTIONS: Record<PostnordJob, string> = {
  shipment_motor: 'Skapar och bokar leveranser hos PostNord.',
  shipment_tracking: 'Synkroniserar leveransstatus med PostNord.'
}
